<template>
	<property name="Земельный участок" :value="doc.spatialUnit">
	</property>
</template>
<script>
	import Property from '@/components/common/Property'
	export default {
		props: ['doc'],
		components: {			
			Property
		},
	}
</script>
